import { axiosInstance } from "./axios";
import { IClient } from "dto/IClient";
import { IError } from "dto/IError";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IClientFile } from "dto/IClientFile";

const queryKeys = {
  getClient: (clientId: number | string) => [
    "clientService.getClient",
    clientId,
  ],
  getFiles: (clientId: number) => ["clientService.getClientFiles", clientId],
};

const getClient = (clientId: string | number): Promise<{ data: IClient }> => {
  return axiosInstance.get(`/client?id=${clientId}`);
};

const useGetClient = (clientId: string | number, enabled = true) => {
  return useCustomQuery(
    queryKeys.getClient(clientId),
    () => getClient(clientId),
    {
      enabled: enabled,
    }
  );
};

const getClientFiles = (clientId: number): Promise<{ data: IClientFile[] }> => {
  return axiosInstance.get(`/client/files?id=${clientId}`);
};

const useGetClientFiles = (clientId: number, enabled = true) => {
  return useCustomQuery(
    queryKeys.getFiles(clientId),
    () => getClientFiles(clientId),
    {
      enabled: enabled,
    }
  );
};

export interface IUpdateClient {
  Id: number;
  IsInstitution: boolean;
  Name: string;
  Address: string;
  StreetId: string;
  City: string;
  CityId: string;
  ZipCode: string;
  Phone: string;
  Email: string;
  Note: string;
  NIP: string;
  REGON: string;
  ContactPersons: any[];
  TagIds: string[];
  NewTags: string[];
}

export interface ICreateClientFile {
  ClientId: number;
  Uri: string;
}

export interface IRemoveClientFile {
  Id: string;
}

export interface ClientData {
  Type: string;
  Value: string | null;
  IsMain: boolean;
}

export interface ICreateClient {
  IsInstitution: boolean | null;
  Name: string | null;
  NIP?: string | null;
  REGON?: string | null;
  KRS?: string | null;
  Data: ClientData[] | null;
  TagIds: string[] | null;
  // WorkspaceId: string | null;
  // WorkspaceRoleId: string | null;
}

export interface INewUpdateClient {
  Id: string | number;
  IsInstitution: boolean | null;
  Name: string | null;
  NIP?: string | null;
  REGON?: string | null;
  KRS?: string | null;
  Data: ClientData[] | null;
  TagIds: string[] | null;
  // WorkspaceId: string | null;
  // WorkspaceRoleId: string | null;
}

const createClient = (payload: ICreateClient): Promise<{ data: IClient }> => {
  return axiosInstance.post("/client", payload);
};

const useCreateClient = () => {
  return useCustomMutation(createClient);
};

const updateClient = (payload: IUpdateClient): Promise<{ data: IClient }> => {
  return axiosInstance.put("/client", payload);
};

const useUpdateClient = () => {
  return useCustomMutation(updateClient);
};

const newupdateClient = (
  payload: INewUpdateClient
): Promise<{ data: IClient }> => {
  return axiosInstance.put("/client", payload);
};

const useNewUpdateClient = () => {
  return useCustomMutation(newupdateClient);
};

export interface IDeleteClient {
  Id: string | number;
}

const deleteClient = (payload: IDeleteClient): Promise<{ data: IError }> => {
  return axiosInstance.delete("/client", {
    data: payload,
  });
};

const useDeleteClient = () => {
  return useCustomMutation(deleteClient);
};

const createClientFile = (
  payload: ICreateClientFile
): Promise<{ data: IClientFile }> => {
  return axiosInstance.post("/client/file", payload);
};

const useCreateClientFile = () => {
  return useCustomMutation(createClientFile);
};

const deleteClientFile = (
  payload: IRemoveClientFile
): Promise<{ data: IError }> => {
  return axiosInstance.delete("/client/file", {
    data: payload,
  });
};

const useDeleteClientFile = () => {
  return useCustomMutation(deleteClientFile);
};

export default {
  useGetClient,
  useUpdateClient,
  useDeleteClient,
  useCreateClient,
  useNewUpdateClient,
  useGetClientFiles,
  useCreateClientFile,
  useDeleteClientFile,
};
